/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Scan_Physical_BooksInputs */

const en_mobile_benefits_scan_physical_books = /** @type {(inputs: Mobile_Benefits_Scan_Physical_BooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan physical books`)
};

const es_mobile_benefits_scan_physical_books = /** @type {(inputs: Mobile_Benefits_Scan_Physical_BooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escanea libros físicos`)
};

/**
* | output |
* | --- |
* | "Scan physical books" |
*
* @param {Mobile_Benefits_Scan_Physical_BooksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_scan_physical_books = /** @type {((inputs?: Mobile_Benefits_Scan_Physical_BooksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Scan_Physical_BooksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_scan_physical_books(inputs)
	return en_mobile_benefits_scan_physical_books(inputs)
});